//repeated actions 


export class gameLoop {
    constructor(state, ui, sl) {
        this.state = state;
        this.ui = ui;
        this.saveLoad = sl;
        this.lastTime = 0;
        this.autoSaveTimer = 0;
        this.loop = this.loop.bind(this);
    }
    
    start() {
        this.lastTime = performance.now();
        requestAnimationFrame(this.loop);
    }

    loop(currentTime) {
        const dt = currentTime - this.lastTime;
        this.lastTime = currentTime;

        this.state.update(dt);
        this.ui.update()
        
        this.autoSaveTimer += dt;
        if (this.autoSaveTimer >= 10000) {
            this.autoSaveTimer = 0;

            this.state.lastSaved = Date.now();
            this.saveLoad.saveState();
        }



        requestAnimationFrame(this.loop);
    }
}